import { create, all } from 'mathjs'
const math = create(all,  {number: 'BigNumber', precision: 20});

export const FormatCurrency = (val: number, addDollarSign: boolean=true) => {
	if (isNaN(val)) {
		console.error(`FormatCurrency expected a number but got: ${val}`);
		return addDollarSign ? ('$' + '0.00') : '0.00'
	}

	const valueStr = math.format(Number(val),  {notation: 'fixed', precision: 2})

	return addDollarSign ? ('$' + valueStr) : valueStr
}